import { I18n } from '@/services/i18n';

type Message = {
  header: string;
  letAi: string;
  aiFinds: string;
  endlessSwiping: string;
  breakIce: string;
  firstMove: string;
  disable: string;
  realConnections: string;
  tryIt: string;
  dontWant: string;
};

const messages: I18n<Message> = {
  en: {
    header: 'Smart Match AI',
    letAi:
      'Let our AI handle the hard part — finding your best matches and breaking the ice, so you can focus on the fun part: getting to know amazing people.',
    aiFinds: 'AI finds who’s right for you',
    endlessSwiping: 'No endless swiping — just the most promising matches, chosen just for you.',
    breakIce: 'We break the ice for you',
    firstMove: 'Our AI starts the conversation so you never have to worry about the first move.',
    disable: 'You can disable Smart Match AI in the settings.',
    realConnections:
      'No awkward first texts. No endless swiping.<br />Just real connections – made easy!',
    tryIt: 'Try it free',
    dontWant: 'I don’t want',
  },
  es: {
    header: '',
    letAi: '',
    aiFinds: '',
    endlessSwiping: '',
    breakIce: '',
    firstMove: '',
    disable: '',
    realConnections: '',
    tryIt: '',
    dontWant: '',
  },
  de: {
    header: 'Smart Match AI',
    letAi:
      'Lass unsere KI die schwere Arbeit übernehmen – sie findet deine besten Matches und sorgt für den Gesprächseinstieg, damit du dich auf das Kennenlernen konzentrieren kannst.',
    aiFinds: 'KI findet, wer zu dir passt',
    endlessSwiping:
      'Kein endloses Swipen – nur die vielversprechendsten Matches, speziell für dich ausgewählt.',
    breakIce: 'Wir brechen das Eis für dich',
    firstMove:
      'Unsere KI startet das Gespräch, sodass du dir keine Sorgen um den ersten Schritt machen musst.',
    disable: 'Du kannst Smart Match AI in den Einstellungen deaktivieren.',
    realConnections:
      'Keine peinlichen ersten Nachrichten. Kein endloses Swipen.<br />Echte Verbindungen – ganz einfach!',
    tryIt: 'Jetzt kostenlos testen',
    dontWant: 'Ich möchte nicht',
  },
};

export { messages };
